// Worker Events
export const WORKER_IMAGE_CANVAS_TO_BLOB = 'worker_image_canvas_to_blob';
export const WORKER_MESSAGES_FETCH_THREADS = 'worker_messages_fetch_threads';
export const WORKER_MESSAGES_FETCH_THREAD = 'worker_messages_fetch_thread';
